var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 100,
    viewBox: "0 0 251 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(1 0 0 -1 219.502 49.5014)",
    fill: "#E3E0FB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(1 0 0 -1 239.502 74.5014)",
    fill: "#E3E0FB"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(1 0 0 -1 29.5 39.5014)",
    fill: "#E3E0FB"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(1 0 0 -1 6.5 18.5014)",
    fill: "#E3E0FB"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(1 0 0 -1 193.502 72.5014)",
    fill: "#E3E0FB"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(1 0 0 -1 199.502 20.4975)",
    fill: "#E3E0FB"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(1 0 0 -1 4.5 68.5014)",
    fill: "#E3E0FB"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(1 0 0 -1 56.502 19.5014)",
    fill: "#E3E0FB"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(1 0 0 -1 246.5 25.5014)",
    fill: "#E3E0FB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    transform: "matrix(1 0 0 -1 49.5 65.5)",
    fill: "#E3E0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.208 6.5782C151.101 3.47393 147.11 1.64033 142.232 0.631264C134.299 -1.00379 126.068 0.565865 119.152 5.00854C117.164 6.27921 113.008 10.1613 111.449 12.2261C107.391 17.5611 105.091 24.6969 105.223 31.5338C105.305 36.7029 106.39 41.0638 108.657 45.4575L109.839 47.7372L91.2109 66.6314L72.5824 85.5257L72.2874 86.5487C71.8762 87.9199 71.9088 89.8025 72.3687 91.1573C72.6475 92.0332 73.0261 92.5774 73.9786 93.5351C75.4235 94.988 76.7384 95.5509 78.692 95.5345C80.7131 95.5509 81.6981 95.1211 83.5216 93.4534L85.099 92.0005L88.7462 95.6677C91.9334 98.8724 92.5072 99.3512 93.3458 99.6642C95.1694 100.342 96.7955 99.9936 98.1591 98.6248C99.7202 97.0551 99.7365 94.4624 98.1754 92.4303C97.1068 91.0265 97.2067 90.4986 98.784 88.9126C100.313 87.3756 101.019 87.1958 101.971 88.1534C102.612 88.7981 104.352 89.5245 105.289 89.5736C107.342 89.6881 109.51 87.8404 109.707 85.792C109.953 83.5613 109.839 83.3464 105.6 78.9878L101.839 75.1057L110.676 66.2857L119.529 57.4821L121.796 58.6711C126.166 60.9508 130.503 62.0393 135.644 62.1234C142.443 62.2565 149.54 59.9441 154.846 55.8634C156.9 54.2938 160.76 50.115 162.024 48.1179C168.694 37.5812 168.661 24.2345 161.91 13.9453C160.382 11.6492 157.097 8.01472 155.208 6.5782ZM150.953 21.9898C154.419 27.4906 154.237 35.3014 150.541 40.8676C145.368 48.6458 134.838 50.9092 126.837 45.9386C125.195 44.9156 122.337 42.0402 121.318 40.3888C117.194 33.6991 117.933 25.3253 123.141 19.4297C125.26 17.0355 127.297 15.6808 130.468 14.5736C138.239 11.8804 146.502 14.8703 150.953 21.9898Z",
    fill: "#E3E0FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.1a78f0796fd2494a82cc2afa3fa074a1.svg";
export { ForwardRef as ReactComponent };